<template>
  <BaseWidget
    :class="['accountant-customers', widget.type]"
    :loading="loading"
    @refresh-data="refreshData"
    @set-config="setConfig"
    v-on="$listeners"
  >
    <template v-slot:header>
      <div class="title">
        <span class="title-icon"> </span>
        {{ title }}
      </div>
      <!-- <div class="description">{{ subtitle }}</div> -->
    </template>
    <template v-slot:content>
      <div v-if="accountantConnectionTotals" class="data-wrap">
        <div class="data-item connected">{{ accountantConnectionTotals.connected }} <span>{{ $gettext('Connected') }}</span></div>
        <div class="data-item pending">{{ accountantConnectionTotals.pending}} <span>{{ $gettext('Pending invites') }}</span></div>
        <div class="data-item premium">{{ accountantConnectionTotals.premium }} <span>{{ $gettext('Premium') }}</span></div>
        <div class="data-item disconnected">{{ accountantConnectionTotals.disconnected }} <span>{{ $gettext('Disconnected') }}</span></div>
      </div>
    </template>
    <template v-slot:actions>
       <GekkoButton 
          @click="$router.push({ name: 'Clients' })"
          :text="$gettext('See my clients')" 
          variant="link"
          class="text-blue p-0"
          size="sm"
        />
    </template>
  </BaseWidget>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BaseWidget from '@/components/dashboard/widgets/BaseWidget'
import GekkoButton from '@/components/GekkoButton';

export default {
  name: 'accountant-customers-widget',
  components: {
    BaseWidget,
    GekkoButton
   },
  props: {
    widget: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: true,
      title: '',
      subtitle: '',
      config: { status: '' },
      filters: {},
    }
  },
  computed: {
    ...mapGetters({
      getCompanyId: 'main/getCompanyId',
      accountantConnectionTotals: 'accountants/getAccountantConnectionTotals'
    })
  },
  mounted() {
    this.setupWidget()
    this.setObjectStatus(this.widget.config)
  },
  methods: {
    ...mapActions({
      loadAccountantConnectionTotals: 'accountants/loadAccountantConnectionTotals'
    }),
    setConfig(config) {
      if (config.status) this.setObjectStatus(config)
      this.$emit('save-config', this.config)
    },
    setupWidget() {
      this.title = this.$gettext('Your Clients')
      this.subtitle = this.$gettext('Client connection summary')
      this.getData()
    },
    setObjectStatus (config) {
      if (config.status) {
        this.config.status = (config.status && config.status !== 'all') ? config.status : ''
      } 
    },
    refreshData () {
      this.getData()
    },
    getData() {
      this.loading = true
      this.loadAccountantConnectionTotals().then(() => {
        this.loading = false
      })
    },
  },
}
</script>

<style lang="scss">
.accountant-customers {
  .data-wrap {
    display: flex;
    gap: 2rem;
    font-family: $fontMedium;
    width: 100%;
    height: 100%;
    justify-content: space-evenly;

    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;

    .data-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 30px;
      line-height: 1.3;

      padding: 14px 16px;
      border: 1px solid #eef1f4;
      border-radius: 12px;
      background: #fafbfc;

      span {
        font-family: $fontRegular;
        font-size: 14px;
        color: $colorTextSemi;
        white-space: nowrap;
      }
      &.connected { color: $colorBrand; }
      &.premium { color: $colorGold; }
      &.disconnected { color: $colorDanger; }
      &.pending { color: $colorWarning; }
    }
  }
}
</style>
